import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const HeaderTimeWeather: React.FC = () => {
  const [currentTimeUTC, setCurrentTimeUTC] = useState<string>('');
  const [currentDateUTC, setCurrentDateUTC] = useState<string>('');

  // Update time every second
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      // UTC time
      const utcTime = now.toLocaleTimeString('en-GB', {
        timeZone: 'UTC',
        hour: '2-digit',
        minute: '2-digit',
      });
      setCurrentTimeUTC(utcTime);

      // UTC date
      const utcDate = now.toLocaleDateString('en-GB', {
        timeZone: 'UTC',
        day: '2-digit',
        month: 'short',
      });
      setCurrentDateUTC(utcDate);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);


  return (
    <Box
      sx={{
        display: { xs: 'none', md: 'flex' }, // Show on medium screens and up
        alignItems: 'center',
        justifyContent: 'center',
        mr: 1,
      }}
    >
      {/* Time Display - UTC only */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: '#666',
            fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
          }}
        >
          {currentDateUTC} {currentTimeUTC}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: '#999',
            fontWeight: 500,
          }}
        >
          UTC
        </Typography>
      </Box>
    </Box>
  );
};

export default HeaderTimeWeather;